import React from 'react'
import Exporting from '../Exporting';

const Sortition = ({ setSortText, columns, hasSorting, options, isDiv, setColsToShow,
    colsToShow, isDynamicColumns = false, exportDataModel }) => {
    const [sortList, setSortList] = React.useState([]);
    React.useEffect(() => {
        if (columns && columns.length > 0) {
            let temp = []
            columns.forEach(col => {
                let tempModel = { ...col }
                tempModel.show = true
                temp.push(tempModel)
            })

            setColsToShow([...temp])
        }
    }, [])

    const handleSortClick = (e, col) => {
        const list = clickSortItem(e, col, sortList);
        setSortList([...list])
        setSortText({ sortText: createSortText(list) })

    }

    const getSortItem = (col) => {
        const property = col.filterProperty ? col.filterProperty : col.property

        const selectedItemIdx = sortList.length > 0 ?
            sortList.map(item => item.property).indexOf(property) : -1
        if (selectedItemIdx > -1) {
            return { type: sortList[selectedItemIdx].type, index: selectedItemIdx }
        }
        return false
    }

    const renderableColumns = () => {

        return colsToShow.filter(item => item.display === true && item.show);
    }


    return (
        <>
            {!isDiv ? <tr>
                {renderableColumns().map((column, idx) => {
                    const colState = getSortItem(column)

                    return (<th key={idx} className={`${idx === renderableColumns().length - 1 ? 'tool-context' : ''}`} >
                        <div>
                            {hasSorting && column.hasSort ?
                                <span onClick={(e) => handleSortClick(e, column)}>
                                    {column.title}
                                    {colState && <span className='sort-displayer'>
                                        {sortList.length > 1 && <span>{colState.index + 1}</span>}
                                        <span>
                                            {colState.type === "ASC" ? <ArrowUp /> : colState.type === "DESC" ? <ArrowDown /> : ''}
                                        </span>

                                    </span>}
                                </span> : <span>{column.title}</span>}
                            {isDynamicColumns && <span className='hide-col' onClick={() => {
                                const temp = [...colsToShow]
                                const showings = colsToShow.filter(i => i.show)
                                if (showings.length > 1) {
                                    temp[colsToShow.map(i => i.title).indexOf(column.title)].show = false
                                    setColsToShow([...temp])
                                }
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z" /></svg>
                            </span>}

                            {idx === renderableColumns().length - 1 && isDynamicColumns && <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg>
                                <ul>
                                    {exportDataModel &&
                                        <Exporting
                                            columns={colsToShow}
                                            exportDataModel={exportDataModel} />}

                                    {colsToShow.map((_column, idx) => {
                                        if (_column.display) {
                                            return (<li key={idx} onClick={() => {
                                                const temp = [...colsToShow]
                                                const showings = colsToShow.filter(i => i.show)
                                                if (temp[idx].show) {
                                                    if (showings.length > 1) {
                                                        temp[idx].show = !temp[idx].show
                                                        setColsToShow([...temp])
                                                    }
                                                } else {
                                                    temp[idx].show = !temp[idx].show
                                                    setColsToShow([...temp])
                                                }


                                            }}>{_column.title}

                                                {_column.show ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg>
                                                    :
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z" /></svg>
                                                }
                                            </li>)
                                        }
                                    }
                                    )}
                                </ul>
                            </div>}
                        </div>

                    </th>)


                })}
                {options && <th>{columns.some(item => item.isOptionTitle) && columns.find(item => item.isOptionTitle).title}</th>}
            </tr> :
                <div className='tv-head'>
                    {renderableColumns().map((column, idx) => {
                        const colState = getSortItem(column)
                        return (<div key={idx} >

                            {hasSorting && column.hasSort ?
                                <span onClick={(e) => handleSortClick(e, column)}>
                                    {column.title}
                                    {colState && <span className='sort-displayer'>
                                        {sortList.length > 1 && <span>{colState.index + 1}</span>}
                                        <span>
                                            {colState.type === "ASC" ? <ArrowUp /> : colState.type === "DESC" ? <ArrowDown /> : ''}
                                        </span>

                                    </span>}
                                </span> : <span>{column.title}</span>}
                        </div>)

                    })}
                    {options && <th>{columns.some(item => item.isOptionTitle) && columns.find(item => item.isOptionTitle).title}</th>}
                </div>
            }

        </>

    )
}

export default Sortition

const createSortText = (list) => {
    let str = "";
    list.map((item, idx) => {
        if (idx === 0) {
            str += `${item.property} ${item.type}`
        } else {
            str += `,${item.property} ${item.type}`

        }
    })
    return str;
}


const clickSortItem = (e, col, list) => {
    let tempList = list;
    const property = col.filterProperty ? col.filterProperty : col.property
    if (e.shiftKey) {
        let idx = -1;
        if (tempList.some(item => item.property === property)) {
            tempList.map((item, i) => {
                if (item.property === property) {
                    if (item.type === "ASC") {
                        item.type = "DESC"
                    } else if (item.type === "DESC") {
                        idx = i
                    }
                }
            })
            if (idx > -1) {
                tempList = tempList.filter(item => item.property !== property)
            }
        } else {
            tempList.push({ property: property, type: "ASC" })
        }
        return tempList;

    } else {
        let oldSelected = tempList.find(item => item.property === property);
        if (oldSelected) {
            if (oldSelected.type === "ASC") {
                oldSelected.type = "DESC"
                return [{ ...oldSelected }]
            } else if (oldSelected.type === "DESC") {
                return []

            }
        } else {
            return [{ property: property, type: "ASC" }]
        }
    }
}


export const ArrowUp = ({ width = 24, height = 24, fill, styles }) => {
    return (
        <svg style={{ ...styles, width, height, verticalAlign: "middle" }} viewBox="0 0 24 24">
            <path d="M7.03 9.97H11.03V18.89L13.04 18.92V9.97H17.03L12.03 4.97Z" />
        </svg>
    );
};


export const ArrowDown = ({ width = 24, height = 24, fill, styles }) => {
    return (
        <svg style={{ ...styles, width, height, verticalAlign: "middle" }} viewBox="0 0 24 24">
            <path d="M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z" />
        </svg>
    );
};